<template>
  <div>
    <div
      v-if="!isInrTransactionCompleted"
      class="conversion-rate-widget-container p-0 p-md-3"
    >
      <img
        src="@/assets/images/common/inr-banner-background.svg"
        class="widget-background-image"
        width="50%"
      />
      <div
        class="d-flex flex-column justify-content-center text-content px-3 px-md-0"
      >
        <p class="header">
          {{ $t('dashboard.conversionRateDetailsWidget.title') }}
        </p>
        <p class="sub-header">
          {{ $t('dashboard.conversionRateDetailsWidget.subTitle') }}
        </p>
      </div>
      <div class="d-flex p-3 p-md-0">
        <action-button variant="solid" :click="openDialog" class="mr-3">
          {{ $t('dashboard.conversionRateDetailsWidget.enableINRButtonText') }}
        </action-button>
        <action-button
          variant="text"
          v-if="!hideKnowMore"
          :click="redirectToCurrencySettings"
        >
          {{ $t('dashboard.conversionRateDetailsWidget.knowMoreButtonText') }}
          <b-icon-chevron-right class="wealthy-green-color ml-2" />
        </action-button>
      </div>
    </div>
    <div v-else class="conversion-rate-widget-container p-3">
      <img
        src="@/assets/images/common/drip-switch-document-background.svg"
        class="widget-background-image alternate"
        width="45%"
      />
      <div class="d-flex flex-column justify-content-center text-content">
        <p class="header">
          {{ $t('dashboard.alternateConversionRateDetailsWidget.title') }}
        </p>
        <p class="sub-header">
          {{ $t('dashboard.alternateConversionRateDetailsWidget.subTitle') }}
        </p>
      </div>
      <div class="d-flex">
        <action-button variant="solid" :click="openDialog">
          {{
            $t(
              'dashboard.alternateConversionRateDetailsWidget.enableINRButtonText'
            )
          }}
        </action-button>
        <action-button
          variant="text"
          v-if="!hideKnowMore"
          :click="redirectToCurrencySettings"
        >
          {{ $t('dashboard.conversionRateDetailsWidget.knowMoreButtonText') }}
          <b-icon-chevron-right class="wealthy-green-color ml-2" />
        </action-button>
      </div>
    </div>
  </div>
</template>
<script>
import { currencyConverter } from '@/utils/common'
import ActionButton from '@/components/common/ActionButton'

export default {
  props: {
    rate: String,
    onStatusToggleSuccess: Function,
    isInrTransactionCompleted: Boolean,
    hideKnowMore: Boolean
  },
  data() {
    return {
      isEnableDripSwitchModalOpen: false,
      bannerType: 'A'
    }
  },
  components: {
    ActionButton
  },
  methods: {
    redirectToCurrencySettings() {
      this.$mpTrack('Clicks "Know More" on the main banner')
      this.$router.push({ name: 'currencySettings' })
    },
    openDialog() {
      if (this.$route.name === 'dashboard') {
        this.$mpTrack('Clicks "Enabled INR payments" on the main banner')
      }
      if (this.$route.name === 'currencySettings') {
        this.$mpTrack(
          'Clicks "Enable INR Payment" on the currency settings page'
        )
      }
      this.$emit('openDialog')
    },

    onModalClose() {
      this.isEnableDripSwitchModalOpen = false
    },
    onGetMyFundsInInr() {
      const screenLevel =
        this.$route.name === 'currencySettings'
          ? 'Currency Settings'
          : 'Dashboard'
      this.$mpTrack(`Get my Funds in INR clicked at ${screenLevel} screen`)
      this.isEnableDripSwitchModalOpen = true
    }
  },
  computed: {
    getEnableDripSwicthApiData() {
      return {
        user_id: this.$store.state.account.accountId,
        enabled: true
      }
    },
    getAmountInINR() {
      if (this.rate) {
        return `₹ ${currencyConverter(this.rate, 1000)}`
      } else {
        return '-'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.conversion-rate-widget-container {
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: $sky-blue-50;
  border-radius: 8px;
  height: 300px;
  margin-bottom: 16px;
  @include media-breakpoint-down(md) {
    height: auto;
  }
  .widget-background-image {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 0;
    height: 100%;
    object-fit: cover;
    &.alternate {
      height: 60%;
      margin: auto;
      margin-right: 16px;
      object-fit: fill;
    }
    @include media-breakpoint-down(md) {
      position: relative;
      width: 100%;
      height: 240px;
      margin-bottom: 24px;
    }
  }
  .text-content {
    width: 54%;
    @include media-breakpoint-down(md) {
      width: 100%;
    }
    .header {
      font-weight: 700;
      font-size: 36px;
      line-height: 42px;
      color: $noble-blue-500;
      margin-bottom: 8px;
    }
    .sub-header {
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      color: $noble-blue-500;
      margin-bottom: 32px;
    }
  }
  .action-button {
    text-align: center;
    height: 56px;
    padding: 18px 24px;
    background: $wealthy-green-500;
    border-radius: 8px;
    color: white;
  }
  .wealthy-green-color {
    color: $wealthy-green-500;
  }
}
</style>
